import React, { useEffect, useRef, useState } from 'react';
import Color from '../../../data/Color';
import Flex from '../../../data/Flex';
import Size from '../../../data/Size';
import UIButton from '../../../ui/UIButton';
import { UIWhiteBox } from '../../../ui/UIContainer';
import UIFlex from '../../../ui/UIFlex';
import { UIForm } from '../../../ui/UIForm';
import UIInput from '../../../ui/UIInput';
import UITitle from '../../../ui/UITitle';
import Api from '../../../api/Api';
import ConfirmOverlay from "../../../ui/overlay/ConfirmOverlay";
import useLoadingState from '../../../hooks/useLoadingState';
import User from '../../../data/User';
import './ManageUser.scss';
import { IUserData } from '../../../data/UserData';
import UIContainer from '../../../ui/UIContainer';
import FormatUtil,{IHash} from '../../../util/FormatUtil';
import NewPasswordOverlay from "../../../ui/overlay/NewPassowrdOverlay";

export interface IUserProps {
    userData:IUserData;
    title?:string;
    onCancel:()=>void;
    onRefresh:(phoneNumber?:string,email?:string,name?:string)=>void;
    action?:string;
}

export interface IUserState{
    PK:string;
    USERNAME:string;
    EMAIL:string;
    USER_ROLE:string;
    emailConfirmation:string;
    PASSWORD:string;
    passwordConfirmation:string;
    resetPassword:string;
    COMPANYID:string;
    SECURITYGROUPID:string;
    PHONE_NUMBER:string;
}

export function ManageUser($props:IUserProps){
    

    const [syncChangesToMap, setSyncToMap] = useState(!User.state.suppressMapUpdates);
    

    const [loadingState, setLoading, setError, setLoadingState, resetLoadingState] = useLoadingState({loading:false});

    const [validFieldsUpdate, setShowValidFieldsUpdate] = useState(false);

    const defaultUserState:IUserState = {
        PK:"",
        USERNAME:"",
        EMAIL:"",
        USER_ROLE:"",
        emailConfirmation:"",
        PASSWORD:"",
        passwordConfirmation:"",
        resetPassword:"",
        COMPANYID:"",
        SECURITYGROUPID:"",
        PHONE_NUMBER:"",
    }

    const [userState, setUserState] = useState<IUserState>(defaultUserState);
    
    const manualInputChange=($value:string | number | boolean, $name:string)=>{        
        setUserState(($prevState)=>{
            let newState:any = {...$prevState};
            newState[$name] = $value;
            return newState;
        });
    }


    const onBlur=($value:string, $name:string)=>{        
        let isEMAILValid:boolean=false;
   
        isEMAILValid = FormatUtil.isValidEmail($value);
   
    }

    const _resetPassword=()=>{        
        let email = userState.EMAIL.trim();  

        let isEmailValid:boolean=false;
        
        isEmailValid = FormatUtil.isValidEmail(email) && email!=="";        

        if(!isEmailValid){
            ConfirmOverlay.show("errorIvalidEMAIL",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"You must enter a valid Email address"});    
            return;
        }   

        const userPasswordClear:any = {};

        userPasswordClear.email = email; 

        Api.cdr.clearPasswordAdmin(($success,$results)=>{
            if($success){
                if($results && $results.summary){
                    ConfirmOverlay.show("successUpdateUser",{confirmLabel:"Ok", hideCancel:true, title:"Password Cleared", message:"Clear Password Successful."});    
                    //NewPasswordOverlay.show("New Password",{title:"",desc:"",message:"Please enter the verification code sent to " + email + " to proceed with password reset.",
                        //sendLabel:"Submit", email:email});

                }
                else{
                    ConfirmOverlay.show("errorUpdateUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Reset Password."});    
                }
            }else{
                ConfirmOverlay.show("errorUpdateUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Reset Password."});
            }
        },{email:userPasswordClear.email});

        {$props.onCancel()};

    }

    const _save=()=>{        

        let email = userState.EMAIL.trim();  
        let userName = userState.USERNAME.trim();  
        let role = userState.USER_ROLE.trim();
        let pk =   userState.PK;
        let emailConfirmation  = userState.emailConfirmation.trim();  
        let password = userState.PASSWORD.trim();
        let passwordConfirmation  = userState.passwordConfirmation.trim();  
        let securityGroupId = userState.SECURITYGROUPID?.trim();
        let phoneNumber = userState.PHONE_NUMBER?.trim();


        let isEmailValid:boolean=false;
        let isEmailConfirmationValid:boolean=false;

        isEmailValid = FormatUtil.isValidEmail(email) && email!=="";
        isEmailConfirmationValid = FormatUtil.isValidEmail(emailConfirmation) && emailConfirmation!=="";

        if(User.state.security_group_id){
            securityGroupId =  User.state.security_group_id;
        }
     
        if(!isEmailValid){
            ConfirmOverlay.show("errorIvalidEMAIL",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"You must enter a valid Email address"});    
            return;
        }   

        if(!isEmailConfirmationValid){
            ConfirmOverlay.show("errorIvalidEMAIL",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"You must enter a valid Email confirmation address"});    
            return;
        }   

        if(email !== emailConfirmation){
            ConfirmOverlay.show("errorIvalidEMAIL",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Email and Email Confirmation must be the same"});    
            return;
        }   
        if(password !== passwordConfirmation){
            ConfirmOverlay.show("errorIvalidPassword",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Password and Password Confirmation must be the same"});    
            return;
        }   

        const userSave:any = {};

        if($props.userData.EMAIL != userState.EMAIL){
            userSave.email = email; 
        }
        if($props.userData.USERNAME != userState.USERNAME){
            userSave.username = userName; 
        }
        if($props.userData.USER_ROLE != userState.USER_ROLE){
            userSave.user_role = role; 
        }

        if(userState.PASSWORD.trim()!==""){
            const encodedPassword: IHash = FormatUtil.encodePassword(userState.EMAIL, userState.PASSWORD);
            userSave.PASSWORD = encodedPassword.dbHash;
        }

       
       userSave.pk=pk;
       userSave.securityGroupId=securityGroupId;
       userSave.PHONE_NUMBER = phoneNumber; 

        if($props.action === "updateUser" || $props.action === "userProfile"){
            if (userSave.pk.trim() == "") {
                ConfirmOverlay.show("errorUpdateUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Update User."});    
                return;
            }

            Api.cdr.updateUser(($success,$results)=>{
                if($success){
                    if($results && $results.summary){
                        ConfirmOverlay.show("updateUser",{confirmLabel:"Ok", hideCancel:true, title:"User Update", message:"User Updated"});
                        $props.onRefresh(phoneNumber, email, userName);
                        $props.onCancel();
                        
                    }
                    else{
                        ConfirmOverlay.show("errorUpdateUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Update User."});    
                    }
                }else{
                    ConfirmOverlay.show("errorUpdateUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Update User."});
                }
            },{username:userSave.username,email:userSave.email,user_role:userSave.user_role,pk:userSave.pk,password:userSave.PASSWORD,phone_number:userSave.PHONE_NUMBER});
        }        
        if($props.action === "addUser"){
            Api.cdr.addUser(($success,$results)=>{
                if($success){
                    if($results && $results.summary){
                        ConfirmOverlay.show("addUser",{confirmLabel:"Ok", hideCancel:true, title:"Add User", message:"User Added"});
                        {$props.onCancel()};
                        $props.onRefresh();
                    }
                    else{
                        ConfirmOverlay.show("errorAddUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Add User."});    
                    }
                }else{
                    ConfirmOverlay.show("errorAddUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Add User."});
                }
            },{username:userSave.username,email:userSave.email,user_role:userSave.user_role,security_group_id:userSave.securityGroupId,phone_number:userSave.PHONE_NUMBER});
        }        
       

    }


    const setUserData=($user:IUserData)=>{
        let newUserState:IUserState = {...userState}

        newUserState.PK = $user.PK;
        newUserState.EMAIL = $user.EMAIL;
        newUserState.USERNAME = $user.USERNAME + "";
        newUserState.USER_ROLE = $user.USER_ROLE + "";
        newUserState.emailConfirmation = $user.EMAIL;
        newUserState.PASSWORD = "";
        newUserState.SECURITYGROUPID= $user.SECURITY_GROUP_ID + "";
        newUserState.PHONE_NUMBER = $user.PHONE_NUMBER + "";

        setUserState(newUserState);

    }


    const _onUserAction=($data:IUserData)=>{
        let userData:IUserData = $data;     
        setUserData(userData);
    }
  
    useEffect(()=>{
        _onUserAction($props.userData);
    },[]);


    let USER_ROLEOptions = FormatUtil.ROLES_AS_UI_OPTIONS;

    let generateFieldsCN:string = "generateFields";

    let canSaveDisabled:boolean=true;

    let canRoleDisabled:boolean= true;

    if($props.action !== "userProfile"){
        canRoleDisabled=false;
    }

    if(userState.EMAIL.trim() && userState.emailConfirmation.trim() && userState.USERNAME.trim() && userState.USER_ROLE.trim()){
        canSaveDisabled=false;
    }

    if(userState.PASSWORD.trim() !== userState.passwordConfirmation.trim()){
        canSaveDisabled=false;
    }

    if(validFieldsUpdate){
        generateFieldsCN+=" flash";
    }



return (
        <UIFlex flex={{direction:Flex.COLUMN,overflowHidden:true}}>
        <UIWhiteBox className='manageUser' flex={{fullWidth:true, style:{gap:20}}}>
            <UITitle flex={{style:{marginBottom:-10}}} title={$props.title}>
            </UITitle>

            <div className="divider"></div>
            <UIForm flex={{style:{gap:20}}} className={generateFieldsCN}>
                <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="Name" name='USERNAME' value={userState.USERNAME} onChange={manualInputChange} isRequired  />    
                <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="Email" name='EMAIL' value={userState.EMAIL} onChange={manualInputChange} onBlur={onBlur} isRequired />     
                <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="Email Confirmation" name='emailConfirmation' value={userState.emailConfirmation} onChange={manualInputChange} isRequired /> 

                {$props.action === "userProfile" && (
                <>
                    <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="Password" type={UIInput.TYPE_PASSWORD} name='PASSWORD' autoComplete={"new-password"} value={userState.PASSWORD} onChange={manualInputChange} />
                    <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="Password Confirmation" type={UIInput.TYPE_PASSWORD} name='passwordConfirmation' autoComplete={"new-password"} value={userState.passwordConfirmation} onChange={manualInputChange}/>
                </>
                )}

                <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="Phone Number" name='PHONE_NUMBER' value={FormatUtil.phoneNumber(userState.PHONE_NUMBER)} onChange={manualInputChange}  />     

                <UIFlex flex={{fullWidth:true, style:{gap:10}}}>    
                    <UIInput disabled={canRoleDisabled} flex={{style:{width:100, flexGrow:1, flexShrink:0}}} fontSize={Size.s14} size={Size.s36} label="User Role" type={UIInput.TYPE_SELECT} onChange={manualInputChange}  options={USER_ROLEOptions} value={userState.USER_ROLE} isRequired name='USER_ROLE' /> 
                </UIFlex>  

            </UIForm>
            <UIContainer flex={{alignItems:Flex.FLEX_END, justifyContent:Flex.FLEX_END, style:{gap:10, marginTop:20}}} >
                  <UIFlex >
                     <UIButton label={"Cancel"}  color={Color.BLUE_PRIMARY} onClick={$props.onCancel}/>
                  </UIFlex>  
                  <UIFlex >   
                     <UIButton  disabled={canSaveDisabled} label={"Save"} onClick={_save} />
                  </UIFlex>
                  {$props.action === "updateUser" && (
                  <UIFlex flex={{style:{paddingLeft:40}}} >   
                     <UIButton  label={"Reset Password"} color={Color.BLUE_PRIMARY} onClick={_resetPassword} />
                  </UIFlex>
                  )
                  } 
             </UIContainer>

        </UIWhiteBox>
        </UIFlex>  
    );
}
